var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 47.125,
    viewBox: "0 0 160 47.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b0ff44;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.237 -63.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.184,
    height: 45.448,
    transform: "translate(163.126 64.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M303.1,65.2v6.327h12.889v38.91h7.025V65.2Z",
    transform: "translate(-112.978 -0.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M187.483,69.36c-2.8-2.689-6.6-4.06-11.3-4.06H158.8v45.184h7.078V94.72h9.878c4.913,0,8.874-1.318,11.674-3.954A14.388,14.388,0,0,0,191.762,79.9a14.241,14.241,0,0,0-4.279-10.545M184.313,79.9a7.562,7.562,0,0,1-2.43,6.063,10.107,10.107,0,0,1-6.867,2.162h-9.244V71.89h9.667a9.329,9.329,0,0,1,6.444,2.162,7.26,7.26,0,0,1,2.43,5.852",
    transform: "translate(-44.726 -0.837)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.741,87.186,98.912,65.2h-8.4L75.089,83.811h0l-.211.264H71.973V65.2H65v32h6.973V90.4h3.011l2.958,3.691,13.1,16.4h8.082Z",
    transform: "translate(-0.36 -0.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.235,138.27a3.943,3.943,0,0,0-4.86,2.694,3.856,3.856,0,0,0,.37,2.958,3.964,3.964,0,0,0,2.377,1.849,3.317,3.317,0,0,0,1,.158,3.855,3.855,0,0,0,3.909-3.856,4.043,4.043,0,0,0-2.8-3.8",
    transform: "translate(0 -35.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.035,63.67a3.944,3.944,0,0,0-4.86,2.694,3.856,3.856,0,0,0,.37,2.958,4.014,4.014,0,0,0,2.324,1.849,3.318,3.318,0,0,0,1,.158,3.914,3.914,0,0,0,3.75-2.8,3.974,3.974,0,0,0-2.588-4.86",
    transform: "translate(-136.537 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.61dfd1967d05a4fbae272f805aac215d.svg";
export { ForwardRef as ReactComponent };